import { useFormContext } from "react-hook-form";
import { AdditionalInfoSummary as SharedAdditionalInfoSummary } from "../../../../../shared/additional-info/AdditionalInfoSummary";
import type { BondRequestFormValues } from "../../schema";

export const AdditionalInfoSummary = () => {
	const { getValues } = useFormContext<BondRequestFormValues>();
	const values = getValues();

	return (
		<SharedAdditionalInfoSummary
			comment={values.quote.additionalInfo?.comment}
			attachments={values.quote.additionalInfo?.attachments}
			commentFieldPath="quote.additionalInfo.comment"
			attachmentsFieldPath="quote.additionalInfo.attachments"
		/>
	);
};
